import { useQuery } from 'react-query';
import Task from '../../models/Task';

function useTask(taskId?: string) {
    return useQuery<Task>(['tasks/', taskId], { enabled: !!taskId });
}

export default useTask;
